var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronWithLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.698 3.923 7 7-7 7c-.7.7-.7 1.8 0 2.5s1.8.7 2.5 0l8.3-8.3c.7-.7.7-1.8 0-2.5l-8.3-8.3c-.7-.7-1.8-.7-2.5 0-.7.8-.7 1.9 0 2.6zm19.3-3.8c1 0 1.8.8 1.8 1.8v18c0 1-.8 1.8-1.8 1.8s-1.8-.8-1.8-1.8v-18c0-.9.8-1.8 1.8-1.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronWithLine);
export default __webpack_public_path__ + "static/media/chevron-with-line.ccd84bb6b856d683c3f4caca9182ad2e.svg";
export { ForwardRef as ReactComponent };